module.exports = __webpack_public_path__ + "img/azmin_eyes.16bd2d3b.jpg";